import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { ACTIVE_LANGUAGES, DEFAULT_LANGUAGE } from './languages';
import en from './messages/en.json';
import tr from './messages/tr.json';

// Cookie'den dil tercihini al
const getLanguageFromCookie = (): string => {
  const cookies = document.cookie.split(';');
  const languageCookie = cookies.find((cookie) =>
    cookie.trim().startsWith('language=')
  );

  if (languageCookie) {
    const language = languageCookie.split('=')[1];
    // Sadece aktif dilleri kabul et
    const isValidLanguage = ACTIVE_LANGUAGES.some(
      (lang) => lang.code === language
    );
    return isValidLanguage ? language : DEFAULT_LANGUAGE;
  }

  return DEFAULT_LANGUAGE;
};

// Dil tercihini cookie'ye kaydet
const setLanguageCookie = (language: string): void => {
  document.cookie = `language=${language}; path=/; max-age=31536000`; // 1 yıl
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
      // Gelecekte eklenecek diller için:
      // de: { translation: de },
      // es: { translation: es },
      // fr: { translation: fr },
      // it: { translation: it },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    debug: import.meta.env.MODE === 'development',
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
      skipOnVariables: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie', 'localStorage'],
      lookupCookie: 'language',
      lookupLocalStorage: 'language',
    },
  });

// Başlangıç dilini cookie'den al ve ayarla
const initialLanguage = getLanguageFromCookie();
i18n.changeLanguage(initialLanguage);

// Dil değişikliklerini dinle ve cookie'ye kaydet
i18n.on('languageChanged', (lng) => {
  setLanguageCookie(lng);
});

export default i18n;
